import { initSuccess, initFailure } from './reducer';

export const googleApiInitSuccess = initSuccess;
export const googleApiInitFailure = initFailure;
